import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcStopIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { FAB } from '@gem/ui-kit';

import { useLeavePageConfirm } from 'APP/hooks/useLeavePageConfirm/useLeavePageConfirm';

import { useProgressRecordPresenter } from './ProgressRecord.presenter';
import styles from './ProgressRecord.styles.m.css';

interface IRecordingSectionProps {
  className?: string;
}

export const ProgressRecord: FC<IRecordingSectionProps> = observer(({ className }) => {
  const { t } = useTranslation();
  const presenter = useProgressRecordPresenter();

  useLeavePageConfirm({
    when: true,
    text: t('common_voice_message_cancel_confirmation'),
  });

  return (
    <div className={className}>
      <FAB
        className={styles.iconStop}
        Icon={IcStopIcon}
        onClick={presenter.onStop}
        size="10"
        theme="1"
      />
      <span className={styles.text}>{t('voice_record_in_progress')}...</span>
      <span className={styles.record} />
      <span className={styles.timer}>{presenter.time}</span>
    </div>
  );
});
